import * as React from "react";
import { IState } from "../../store/types";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { closeSnackBar } from "actions/snackBar";

export const SnackBar = () => {
  const snackState = useSelector((state: IState) => state.snackBarState);
  const dispatch = useDispatch();
  const doCloseSnackBar = React.useCallback(() => {
    dispatch(closeSnackBar());
  }, [dispatch]);

  if (!snackState) {
    return null;
  }

  return (
    <Snackbar
      open={!!snackState}
      autoHideDuration={snackState?.autoHideDuration ?? 10 * 1000}
      onClose={doCloseSnackBar}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ width: "90%" }}
    >
      <Alert
        onClose={doCloseSnackBar}
        severity={snackState?.type ?? "success"}
        sx={{ width: "35%", fontSize: "16px" }}
        elevation={6}
        variant="filled"
      >
        {snackState?.message}
      </Alert>
    </Snackbar>
  );
};
